export default {
      id: "expand-regular-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#expand-regular",
      toString: function () {
        return this.url;
      }
    }